// src/config/navigation.ts
import {
  LayoutDashboard,
  Heart,
  Calendar,
  Activity,
  Building2,
  MessageSquare,
  Image,
  FileText,
  Film,
  Settings as SettingsIcon,
  CreditCard,
  Users,
  UserCheck,
  ShoppingBag,
  ScrollText,
  Shield,
} from "lucide-react";

export interface NavigationItem {
  name: string;
  href: string;
  icon: any;
  resource?: string; // Resource name for permission checking
  roles?: ('admin' | 'author')[]; // Legacy role-based filtering
  children?: {
    name: string;
    href: string;
    icon: any;
    resource?: string;
  }[];
}

export const navigation: NavigationItem[] = [
  {
    name: "Dashboard",
    href: "/",
    icon: LayoutDashboard,
    roles: ['admin', 'author'],
  },
  {
    name: "Members",
    href: "/members",
    icon: UserCheck,
    resource: "members",
    roles: ['admin'],
  },
  {
    name: "Transactions",
    href: "/transactions",
    icon: CreditCard,
    resource: "transactions",
    roles: ['admin'],
  },
  {
    name: "Campaigns", // Events (formerly Donations)
    href: "/donations",
    icon: Heart,
    resource: "donations",
    roles: ['admin'],
  },
  {
    name: "Store",
    href: "/store/products",
    icon: ShoppingBag,
    resource: "products",
    roles: ['admin'],
    children: [
      {
        name: "Products",
        href: "/store/products",
        icon: ShoppingBag,
        resource: "products",
      },
      {
        name: "Orders",
        href: "/store/orders",
        icon: ScrollText,
        resource: "orders",
      },
    ],
  },
  {
    name: "Events",
    href: "/events",
    icon: Calendar,
    resource: "events",
    roles: ['admin'],
  },
  {
    name: "Activities",
    href: "/activities",
    icon: Activity,
    resource: "activities",
    roles: ['admin'],
  },
  {
    name: "Partners",
    href: "/partners",
    icon: Building2,
    resource: "partners",
    roles: ['admin'],
  },
  {
    name: "Contacts",
    href: "/contacts",
    icon: MessageSquare,
    resource: "contacts",
    roles: ['admin'],
  },
  {
    name: "Blogs",
    href: "/blogs",
    icon: FileText,
    resource: "blogs",
    roles: ['admin', 'author'],
  },
  {
    name: "Media",
    href: "/media",
    icon: Film,
    resource: "media",
    roles: ['admin'],
  },
  {
    name: "Posters",
    href: "/posters",
    icon: Image,
    resource: "posters",
    roles: ['admin'],
  },
  {
    name: "Roles",
    href: "/roles",
    icon: Shield,
    resource: "roles",
    roles: ['admin'],
  },
  {
    name: "Users",
    href: "/users",
    icon: Users,
    resource: "users",
    roles: ['admin'],
  },
  {
    name: "Settings",
    href: "/settings",
    icon: SettingsIcon,
    roles: ['admin', 'author'],
  },
];
